import type { RiskSeverity, RiskStatus } from '../api/types';
import { RISK_SEVERITY_LABELS, RISK_STATUS_LABELS } from '../lib/risks';
import { Chip, type ChipTone } from './status-chip';
import type { IconName } from './icons';

const SEVERITY_CHIP: Record<RiskSeverity, { tone: ChipTone; icon: IconName }> = {
  high: { tone: 'error', icon: 'alert' },
  medium: { tone: 'check', icon: 'alert' },
  low: { tone: 'filed', icon: 'minus' },
};

const STATUS_CHIP: Record<RiskStatus, { tone: ChipTone; icon: IconName }> = {
  open: { tone: 'neutral', icon: 'help' },
  mitigating: { tone: 'classified', icon: 'refresh' },
  resolved: { tone: 'certified', icon: 'check' },
};

/** A risk's severity as a chip — word + icon + colour ("High severity" to a screen reader). */
export function RiskSeverityChip({ severity }: { severity: RiskSeverity }) {
  const spec = SEVERITY_CHIP[severity];
  return (
    <Chip tone={spec.tone} icon={spec.icon}>
      {RISK_SEVERITY_LABELS[severity]}
      <span className="sr-only"> severity</span>
    </Chip>
  );
}

/** A risk's status as a chip. */
export function RiskStatusChip({ status }: { status: RiskStatus }) {
  const spec = STATUS_CHIP[status];
  return (
    <Chip tone={spec.tone} icon={spec.icon}>
      {RISK_STATUS_LABELS[status]}
    </Chip>
  );
}
